import { getObjectGrowthCardColumns } from "./ObjectGrowthCard.config";

import ObjectGrowthCard from "./ObjectGrowthCard";

const ObjectGrowthCardContainer = ({ items }: any) => {
  const columns = getObjectGrowthCardColumns();

  return <ObjectGrowthCard items={items} columns={columns} />;
};

export default ObjectGrowthCardContainer;
